import Screens from './screens';
import OutOfViewport from './out-of-viewport';

export default {
    screens: Screens,
    outOfViewport: OutOfViewport,
}
